export const KeyLanguageLocalStorageConstant: string = 'language'
